import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseSectionComponent} from "../base-section/base-section.component";
import {TinyPostComponent} from "../../elements/tiny-post/tiny-post.component";
import {TinyPostFromIdPipe, TinyPostsFromIdsPipe} from "../../../pipes/tinyPostFromId/tiny-post-from-id.pipe";
import {PageListPagesSection} from "../../../models/Page/Sections/PageListPagesSection";
import {PageListLinksSection} from "../../../models/Page/Sections/PageListLinksSection";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {RouterLink} from "@angular/router";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";

@Component({
  selector: 'list-links-section',
  standalone: true,
  imports: [CommonModule, BaseSectionComponent, TinyPostFromIdPipe, TinyPostComponent, MediaAttachmentComponent, AttachmentFromIdPipe, RouterLink, SafeHtmlPipe],
  templateUrl: './list-links-section.component.html',
  styleUrl: './list-links-section.component.scss'
})
export class ListLinksSectionComponent extends BaseSectionComponent<PageListLinksSection> implements OnInit{
  sizeXL : number = 10
  sizeLG : number = 10;
  sizeMD : number = 10;
  sizeSM : number = 10;
  sizeXS : number = 10;

  override ngOnInit() {
    super.ngOnInit();
    for(let link of this.sectionRendered.links){
      try{
        const urlObj = new URL(link.link);
        link.external = !link.link.includes('www.visitvar.fr') && !link.link.includes('www.visitvar.com');
        link.link = !link.external ? urlObj.pathname : link.link;
        link.fragment = urlObj.hash.replace('#','');
      }catch (e) {}
    }
  }


}
